import { apolloClient } from '~/apollo-client';
import {
  Flex_FetchBillpayEligibilityQuery,
  Flex_FetchBillpayEligibilityQueryVariables,
} from '~/typings/graphql';
import { FETCH_BILLPAY_ELIGIBILITY } from './fetch-billpay-eligibility.queries';

export const fetchBillpayEligibility = async (
  params: FetchBillpayEligibilityParams,
): Promise<FetchBillpayEligibilityResponse> => {
  const { data } = await apolloClient.query<
    Flex_FetchBillpayEligibilityQuery,
    Flex_FetchBillpayEligibilityQueryVariables
  >({
    query: FETCH_BILLPAY_ELIGIBILITY,
    variables: {
      utilityId: params.utilityId,
    },
  });

  return { billpayEligibile: data.utility.products.some(p => p.key === 'bill_pay_service') };
};

export interface FetchBillpayEligibilityParams {
  utilityId: number;
}

export interface FetchBillpayEligibilityResponse {
  billpayEligibile: boolean;
}
